import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo4/poblacion.png";
import Imagen2 from "../../../images/modulo4/personasciudad.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo4 } from "../../../routes/Module4";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo4/Actividad 2.mp3";

const Actividad2 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: 15 },
    ans2: { value: "", valid: "", correctValue: 15 },
    ans3: { value: "", valid: "", correctValue: 24 },
    ans4: { value: "", valid: "", correctValue: 6 },
  });
  const infoUnidad = modulo4.content[0];
  const infoAct = modulo4.content[0].activities[1];
  const crumbs = [
    {
      title: modulo4.title,
      url: "/" + modulo4.url,
    },
    {
      title:
        modulo4.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo4.content[0].activities[2].name}`,
    linkNext: `${modulo4.url}/${modulo4.content[0].path}/${modulo4.content[0].activities[2].path}`,
    titlePrev: `${modulo4.content[0].activities[0].name}`,
    linkPrev: `${modulo4.url}/${modulo4.content[0].path}/${modulo4.content[0].activities[0].path}`,
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"] === answers[key]["value"]
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...answers, newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: Number(event.target.value) },
    });
  };
  const metadata = {
    color: modulo4.color,
    title: `${modulo4.title} - ${infoAct.name}`,
    name: modulo4.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo4.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">Actividad 2</h2>
      <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-md-12 col-sm-12 mb-5">
          <ul className="mb-5">
            <li>
              El Perú tiene más de 30 millones de habitantes.
            </li>
            <li>
              Imagina que cada persona de las ilustraciones representa a un
              millón de personas y responde las preguntas con ayuda de tu
              profesor, profesora o familiar.
            </li>
          </ul>
          <p>1. ¿Cuántos hombres viven en el Perú? ¿Cuántas mujeres?</p>
          <img src={Imagen1} alt="Familia" className="img-fluid" />
          <div className="row mb-5 mt-3">
            <div className="col-md-6 col-xs-12">
              <div className="row g-3 align-items-center">
                <div className="col-auto">Hombres:</div>
                <div className="col-auto">
                  <input
                    type="text"
                    className={"form-control " + answers.ans1.valid}
                    value={answers.ans1.value}
                    onChange={(event) => handleAnswers(event, "ans1")}
                  />
                </div>
                <div className="col-auto">millones</div>
              </div>
            </div>
            <div className="col-md-6 col-xs-12">
              <div className="row g-3 align-items-center">
                <div className="col-auto">Mujeres:</div>
                <div className="col-auto">
                  <input
                    type="text"
                    className={"form-control " + answers.ans2.valid}
                    value={answers.ans2.value}
                    onChange={(event) => handleAnswers(event, "ans2")}
                  />
                </div>
                <div className="col-auto">millones</div>
              </div>
            </div>
          </div>
          <p>2. ¿Cuántas personas viven en la ciudad? ¿Cuántas en el campo?</p>
          <img src={Imagen2} alt="Familia" className="img-fluid" />
          <div className="row mb-5 mt-3">
            <div className="col-md-6 col-xs-12">
              <div className="row g-3 align-items-center">
                <div className="col-auto">Ciudad:</div>
                <div className="col-auto">
                  <input
                    type="text"
                    className={"form-control " + answers.ans3.valid}
                    value={answers.ans3.value}
                    onChange={(event) => handleAnswers(event, "ans3")}
                  />
                </div>
                <div className="col-auto">millones</div>
              </div>
            </div>
            <div className="col-md-6 col-xs-12">
              <div className="row g-3 align-items-center">
                <div className="col-auto">Campo:</div>
                <div className="col-auto">
                  <input
                    type="text"
                    className={"form-control " + answers.ans4.valid}
                    value={answers.ans4.value}
                    onChange={(event) => handleAnswers(event, "ans4")}
                  />
                </div>
                <div className="col-auto">millones</div>
              </div>
            </div>
          </div>
          <div className="d-flex w-100 justify-content-end my-4">
            <button
              className={`btn btn-${modulo4.color}`}
              onClick={validateAnswers}
            >
              Enviar respuestas
            </button>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes y ayude a identificar
          cuántos hombres y mujeres hay, cuánta gente vive en el campo y cuánta
          en la ciudad. Recuerde que se trata de millones de personas. Finalice
          destacando que hay igual proporción de hombres y mujeres, pero que
          cada vez más gente vive en zonas urbanas.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
